import React from "react";
import { SiDiscord } from "react-icons/si";
import "./FightClub.css";

const GAMES = [
  {
    img: "/games/among-us.webp",
    name: "Among Us",
    tag: "Party",
    description: "Someone in this room is lying. Figure out who before they pick the crew off one by one.",
  },
  {
    img: "/games/chess.png",
    name: "Chess",
    tag: "Competitive",
    description: "No luck, no excuses. Outthink your opponent across 64 squares in the most ruthless game ever made.",
  },
  {
    img: "/games/clash-royale.jpg",
    name: "Clash Royale",
    tag: "Competitive",
    description: "Build your deck, read your opponent, destroy their towers. Real-time card battles, no second chances.",
  },
  {
    img: "/games/gartic.png",
    name: "Gartic / Skribbl",
    tag: "Party",
    description: "Draw, guess, and descend into chaos. Fast rounds that expose exactly how bad everyone's art skills are.",
  },
  {
    img: "/games/haxball.png",
    name: "Haxball",
    tag: "Competitive",
    description: "Tiny ball. Tiny room. Maximum intensity. Team physics football where one bad touch costs the match.",
  },
  {
    img: "/games/putt-party.png",
    name: "Putt Party",
    tag: "Party",
    description: "Minigolf with friends. Race through wild courses and pray your ball doesn't fly off into the void.",
  },
];

const MORE_CARD = { more: true };

const FightClub = () => (
  <div className="fc-page">

    {/* Hero */}
    <section className="fc-hero">
      <div className="fc-hero-glow" aria-hidden="true" />
      <div className="container">
        <div className="fc-hero-inner">
          <h1 className="fc-hero-title font-display">
            Fight <span className="text-gradient-gold">Club</span>
          </h1>
          <p className="fc-hero-sub">
            One Discord. Events hosted regularly — from casual drawing
            sessions to cutthroat ranked matches, and plenty more.
          </p>
          <a
            href="https://discord.gg/UPs824VBqp"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary btn-lg"
          >
            <SiDiscord size={20} />
            <span>Join the Discord</span>
          </a>
        </div>
      </div>
    </section>

    {/* Games Grid */}
    <section className="fc-games">
      <div className="container">
        <div className="fc-grid">
          {[...GAMES, MORE_CARD].map((g) =>
            g.more ? (
              <div key="more" className="fc-card fc-card--more">
                <div className="fc-more-inner">
                  <span className="fc-more-plus">+</span>
                  <p className="fc-more-text">More games hosted in the Discord</p>
                  <a
                    href="https://discord.gg/UPs824VBqp"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fc-more-link"
                  >
                    See what's on →
                  </a>
                </div>
              </div>
            ) : (
              <div key={g.name} className={`fc-card fc-card--${g.tag.toLowerCase()}`}>
                <div className="fc-card-img-wrap">
                  <img src={g.img} alt={g.name} className="fc-card-img" />
                </div>
                <div className="fc-card-body">
                  <span className={`fc-tag fc-tag--${g.tag.toLowerCase()}`}>{g.tag}</span>
                  <h3 className="fc-card-name">{g.name}</h3>
                  <p className="fc-card-desc">{g.description}</p>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </section>

  </div>
);

export default FightClub;
